<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">{{ serviceModel?.id ? "Modifica" : "Nuovo" }} SERVIZIO PARTNER</a>
      </label>
    </div>

    <section class="content-padding darker">
      <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="_serviceForm" (ngSubmit)="onSubmit()">

          <div class="delivery-colle-data-box">
            <fieldset>
              <legend>SERVIZO PER I PARTNER:</legend>

              <div class="col-50 grid-element">
                <label for="name">Nome Servizio*</label>
                <input type="text" name="name" formControlName="serviceName">
                <app-error-html-handler [ctrl]="_serviceForm.get('serviceName')" [messages]="formValidationMsgs.serviceName"></app-error-html-handler>
              </div>

              <div class="col-50 grid-element">
                <label for="name">Tipo Servizio*</label>
                <select name="" id="" formControlName="pricingModel">
                  <option disabled selected="true"></option>
                  <option value="fixedprice">Servizi a Prezzo Fisso</option>
                  <option value="hourlyrate">Services in Ora</option>
                  <option value="sales">Servizi Vendita</option>
                  <option value="corporate">Servizio Aziendale</option>
                  <option value="warehouseservice">Servizio Magazzino</option>
                </select>
                <app-error-html-handler [ctrl]="_serviceForm.get('pricingModel')" [messages]="formValidationMsgs.pricingModel"></app-error-html-handler>
              </div>

              <div class="col-50 grid-element">
                <label for="image">Immagine</label>
                <div *ngIf="imagePath && !removeFile">
                  <a style="float: right; width: auto; color: red; cursor: pointer;" (click)="deleteFile();">×</a>
                  <img [src]="imagePath" class="img-prodotto" alt="Image not Found" style="max-height: 100px; cursor: pointer;" (click)="openImage($event)" />
                </div>
                <input type="file" name="image" (change)="onFileSelect($event)" />
                <app-error-html-handler [ctrl]="_serviceForm.get('image')" [messages]="formValidationMsgs.image">
                </app-error-html-handler>
              </div>

              <!--
              <div class="col-50 grid-element">
                  <label for="sku">Price*</label>
                  <input type="number" name="price" formControlName="price">
                  <app-error-html-handler [ctrl]="_serviceForm.get('price')" [messages]="formValidationMsgs.price"></app-error-html-handler>
              </div>
              -->

              <div class="col-50 grid-element">
                  <label for="sku">Note</label>
                  <textarea formControlName="notes" rows="5" placeholder="Scrivi una descrizione"></textarea>
              </div>
              <div class="grid-element-full">
                <label class="toggle-container" for="hideCustomerInformation">
                  <input type="checkbox" id="hideCustomerInformation" formControlName="hideCustomerInformation">
                  <span class="toggle-switch"></span>
                  Nascondi le informazioni sul destinatario e sul mittente
                </label>
              </div>
        
            </fieldset>

            <div class="center" style="margin-top: 10px;">
              <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!_serviceForm.valid">
                Salva<i class="ml-10 far fa-save"></i>
              </button>
            </div>

          </div>
        </form>
      </div>
    </section>
  </div>
</section>


<!--
<section class="title-bar content-padding first-item content-padding">
    <div class="wrapper">
        <h2 class="left">{{serviceModel?.id ? "Modifica" : "Nuovo"}} Servizio</h2>
        <br class="clear">
    </div>
</section>

<section class="content-padding darker">
    <div class="narrow-wrapper">
      <form class="has-cols" [formGroup]="_serviceForm" (ngSubmit)="onSubmit()">
        <div class="col-50 grid-element">
          <label for="name">Nome Servizio*</label>
          <input type="text" name="name" formControlName="serviceName">
          <app-error-html-handler [ctrl]="_serviceForm.get('serviceName')" [messages]="formValidationMsgs.serviceName"></app-error-html-handler>
        </div>

        <div class="col-50 grid-element">
          <label for="name">Tipo Servizio*</label>
          <select name="" id="" formControlName="pricingModel">
            <option disabled selected="true"></option>
            <option value="fixedprice">Servizi a Prezzo Fisso</option>
            <option value="hourlyrate">Services in Ora</option>
            <option value="sales">Servizi Vendita</option>
            <option value="corporate">Servizio Aziendale</option>
            <option value="warehouseservice">Servizio Magazzino</option>
          </select>
          <app-error-html-handler [ctrl]="_serviceForm.get('pricingModel')" [messages]="formValidationMsgs.pricingModel"></app-error-html-handler>
        </div>

        <div class="col-50 grid-element">
          <label for="image">Immagine</label>
          <div *ngIf="imagePath && !removeFile">
            <a style="float: right; width: auto; color: red; cursor: pointer;" (click)="deleteFile();">×</a>
            <img [src]="imagePath" class="img-prodotto" alt="Image not Found" style="max-height: 100px; cursor: pointer;" (click)="openImage($event)" />
          </div>
          <input type="file" name="image" (change)="onFileSelect($event)" />
          <app-error-html-handler [ctrl]="_serviceForm.get('image')" [messages]="formValidationMsgs.image">
          </app-error-html-handler>
        </div>

        <div class="col-50 grid-element">
            <label for="sku">Note</label>
            <textarea formControlName="notes" rows="5" placeholder="Scrivi una descrizione"></textarea>
        </div>
  
        <div class="center" style="margin-top: 10px;">
          <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!_serviceForm.valid">
            Salva<i class="ml-10 far fa-save"></i>
          </button>
        </div>
      </form>
      <br class="clear">
    </div>
  </section>
-->